module.exports = __webpack_public_path__ + "img/前沿的核心技术.1720c9c4.png";